'use client';

import React from 'react';

interface ProgressBarProps {
  progress: number;
}

export function ProgressBar({ progress }: ProgressBarProps) {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
    <div className='bg-neutral-N00 h-[1px] w-full rounded-full opacity-40'>
      <div
        className='bg-neutral-N99 h-[1px] rounded-full transition-all'
        style={{ width: `${clampedProgress}%` }}
      ></div>
    </div>
  );
}
